import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { Alert, Box, Button } from "@intech/web-ui";

import { EmprestimoService } from "../../services";
import { ContratoEntidade } from "../../entidades";
import { LoadingComponent } from "../../components/LoadingComponent";
import { EmprestimoItem } from "./EmprestimoItem";
import { MasterPage } from "../../components/MasterPage";
import { NumFuncionalidade } from "../../helpers/BloqueioFuncionalidade";
import { FaCalculator } from "react-icons/fa";

export const Emprestimos: React.FC = (props) => {
  const history = useHistory();

  const [AlertText, setAlertText] = useState<string>("");
  const [Emprestimos, setEmprestimos] = useState<Array<ContratoEntidade>>();

  useEffect(() => {
    (async () => {
      try {
        const emprestimos = await EmprestimoService.Buscar(3);
        setEmprestimos(emprestimos);
      } catch (e) {
        if (e.message.indexOf("401") > -1) {
          history.push("/login");
        }
        const error = e.response ? e.response.data : e;
        setAlertText(error);
      }
    })();
  }, []);

  function handleGotoSimulador() {
    history.push("/emprestimoSimulador");
  }

  function renderEmprestimos() {
    if (Emprestimos !== undefined) {
      if (Emprestimos.length > 0) {
        const itens = Emprestimos.map((info: ContratoEntidade, index: number) => {
          return <EmprestimoItem key={index} info={info} />;
        });
        return (
          <Box title={"Empréstimos Concedidos"}>
            <div className={"table-responsive"}>
              <table className={"table table-striped table-sm"}>
                <thead>
                  <tr>
                    <th>Situação</th>
                    <th>Nº/Ano</th>
                    <th>Solicitação</th>
                    <th>Crédito</th>
                    <th>Valor Solicitado</th>
                    <th>Valor Líquido</th>
                    <th>Prazo</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>{itens}</tbody>
              </table>
            </div>
          </Box>
        );
      }

      if (Emprestimos.length === 0) {
        return <Alert type={"danger"}>{"Você não possui nenhum empréstimo concedido com a Faelce."}</Alert>;
      }
    }

    if (AlertText !== "") {
      return <Alert type={"danger"}>{AlertText}</Alert>;
    }

    return <LoadingComponent />;
  }

  return (
    <MasterPage Funcionalidade={NumFuncionalidade.EMPRESTIMOS_CONSULTA} {...props}>
      {/* <Button className="mb-2" icon={<FaCalculator />} onClick={handleGotoSimulador} type={"primary"} title={"Simulador de Empréstimos"} /> */}

      {renderEmprestimos()}
    </MasterPage>
  );
};
